export default __webpack_public_path__ + "static/media/624.2f9d647e.gif";